module.exports = __webpack_public_path__ + "media/images/paper_plane-e584ea698f5e94f87d13b167598c159e.svg";